// A page that names itself after its data (a lot, a seller) hands its title
// and search snippet over here instead of writing document.title directly.
// The router re-applies the generic title on every navigation, language
// switch and when the site settings land — a direct write was lost whenever
// one of those came after the page's own data. An entry holds for its path
// only, so leaving the page drops it without any cleanup.
export interface PageMeta {
  path: string
  title: () => string
  description?: () => string
}

let current: PageMeta | null = null
let reapply: () => void = () => {}

/** The router registers how to re-apply the head tags. */
export function onPageMetaChange(fn: () => void) {
  reapply = fn
}

export function setPageMeta(meta: PageMeta) {
  current = meta
  reapply()
}

export function pageMetaFor(path: string): PageMeta | null {
  return current && current.path === path ? current : null
}
